import { ConnectedAccount } from '@services/stripe-connect/types/connected-account';
import { CreateTransferPayload } from '@services/stripe-connect/types/api/create-transfer-payload';
import { CreateAccountInput } from '@services/stripe-connect/platform/create-account';
import { CallApi, handleJSONResponse } from './common';

const callAPI = CallApi('stripe-connect');

export const getAccount = async (): Promise<ConnectedAccount> => {
  const response = await callAPI('/', 'GET');

  return await handleJSONResponse(response);
};

export const createAccount = async (
  params: CreateAccountInput
): Promise<ConnectedAccount> => {
  const response = await callAPI('/', 'POST', params);

  return await handleJSONResponse(response);
};

export const createOnboardingLink = async (): Promise<void> => {
  const response = await callAPI(`/link`, 'GET', undefined, undefined);

  const { url } = await response.json();

  if (!url) {
    throw new Error('No redirect URL available');
  }

  window.location.assign(url);
};

export const createLoginLink = async (): Promise<void> => {
  const response = await callAPI(`/link/login`, 'GET', undefined, undefined);

  const { url } = await response.json();

  if (!url) {
    throw new Error('No redirect URL available');
  }

  window.open(url, '_blank');
};

export const createTransfer = async (
  payload: CreateTransferPayload
): Promise<void> => {
  const response = await callAPI(`/transfer`, 'POST', payload);

  return await handleJSONResponse(response);
};
